import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762390403135'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='11554'
        width='200'
        height='200'
    >
        <path
            d='M947.2 320c7.04 0 12.8 5.76 12.8 12.8v38.4a12.8 12.8 0 0 1-12.8 12.8H832v518.4a25.6 25.6 0 0 1-25.6 25.6H217.6a25.6 25.6 0 0 1-25.6-25.6V384H76.8a12.8 12.8 0 0 1-12.8-12.8v-38.4c0-7.04 5.76-12.8 12.8-12.8h275.2v466.368a25.6 25.6 0 0 0 20.48 25.024l5.12 0.576h268.8a25.6 25.6 0 0 0 25.6-25.6V320h275.2z'
            p-id='11555'
            fill='currentColor'
        ></path>
        <path
            d='M608 534.336v84.992a25.6 25.6 0 0 1-4.48 14.4l-70.4 103.232a25.6 25.6 0 0 1-42.24 0l-70.4-103.232a25.6 25.6 0 0 1-4.096-9.984L608 534.4z m0-49.92v14.656l-192 89.536v-14.656l192-89.536z m0-49.92v14.592l-192 89.536v-14.656l192-89.472z m0-49.984v14.656l-192 89.536v-14.592l192-89.6z m0-49.92v14.656l-192 89.536v-14.656l192-89.536zM646.4 64c14.08 0 25.6 11.52 25.6 25.6V128l-64 64v107.328l-192 89.536V192l-64-64v-38.4c0-14.08 11.52-25.6 25.6-25.6h268.8z'
            p-id='11556'
            fill='currentColor'
        ></path>
    </svg>
)

export const DrillIcon = props => <Icon component={SVG} {...props} />
